import { AxiosPromise } from 'axios';
import Http from 'shared/http';
import {
  IpAssignment,
  API_PATH_IP_ASSIGNMENTS,
} from './ipAssignment.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function updateIpAssignment(
  deliveryFunctionId: string,
  body: WithAuditDetails<IpAssignment>,
): AxiosPromise<ServerResponse<void>> {
  return http.post(`${API_PATH_IP_ASSIGNMENTS}/${deliveryFunctionId}`, body);
}
